// 화면 문구를 꺼내는 자리 — 문장은 ./ko.ts 한 곳에만 있다(공통 @mops/i18n-v1).
//
// 이름이 `t` 가 아니라 `tx` 인 이유: 이 웹에서 `t` 는 **이슈 한 줄**(TaskRow)의 이름이다 —
// 보드·카드·채팅 겉창이 `(t) => t.status` 처럼 쓰고 IssueCard 의 prop 이름도 `t` 다. 사전 함수를
// `t` 로 두면 그 자리에서 가려져(shadowing) 한 파일 안에서 둘을 같이 못 쓴다.
// 그래서 사전 함수는 어디서나 `tx` 하나로 부른다(docs/decisions/design-system.md 「문구는 사전 한 곳」).
import { createT } from "@mops/i18n-v1";
import { ko } from "./ko";

export const tx = createT(ko);

/** 문장 안 요소 — 공통 `@mops/i18n-v1/react` 의 것을 그대로 쓴다(자체 구현은 지웠다, 공통 1.1).
 *  `rich(tx("k", { err, ...hole("url") }), { url: <code>…</code> })` — 문장은 한 키로 두고 요소 자리만
 *  `hole()` 로 남긴다. 문장을 두 키로 쪼개면 어순이 코드에 박혀 사전에서 문장을 고칠 수 없다. */
export { rich, hole } from "@mops/i18n-v1/react";
